const News = () => {
  return <div className="news"></div>;
};

export default News;
